import { apiGet, apiPost, apiPatch } from './utils';
import type { FieldguideSection, FieldguideEntry } from '../types';

export const fieldguideApi = {
  // ==========================================================================
  // SECTIONS
  // ==========================================================================

  async listSections(
    guideType: string = 'general'
  ): Promise<{ items: FieldguideSection[] }> {
    return apiGet<{ items: FieldguideSection[] }>('/fieldguide/sections', {
      guide_type: guideType,
    });
  },

  async getSection(slug: string): Promise<FieldguideSection> {
    return apiGet<FieldguideSection>(`/fieldguide/sections/${slug}`);
  },

  async createSection(data: {
    name: string;
    guide_type?: string;
    order?: number;
  }): Promise<FieldguideSection> {
    return apiPost<FieldguideSection>('/fieldguide/sections', data);
  },

  async updateSection(
    slug: string,
    data: { name?: string; guide_type?: string; order?: number }
  ): Promise<FieldguideSection> {
    return apiPatch<FieldguideSection>(`/fieldguide/sections/${slug}`, data);
  },

  async deleteSection(slug: string): Promise<{ ok: string }> {
    return apiPost<{ ok: string }>(`/fieldguide/sections/${slug}/delete`);
  },

  // ==========================================================================
  // ENTRIES
  // ==========================================================================

  async listEntries(
    sectionSlug: string
  ): Promise<{ items: FieldguideEntry[] }> {
    return apiGet<{ items: FieldguideEntry[] }>(
      `/fieldguide/sections/${sectionSlug}/entries`
    );
  },

  async getEntry(slug: string): Promise<FieldguideEntry> {
    return apiGet<FieldguideEntry>(`/fieldguide/entries/${slug}`);
  },

  async createEntry(data: {
    section_slug: string;
    title: string;
    content: string;
    content_type?: string;
    order?: number;
  }): Promise<FieldguideEntry> {
    return apiPost<FieldguideEntry>('/fieldguide/entries', data);
  },

  async updateEntry(
    slug: string,
    data: {
      title?: string;
      content?: string;
      content_type?: string;
      order?: number;
    }
  ): Promise<FieldguideEntry> {
    return apiPatch<FieldguideEntry>(`/fieldguide/entries/${slug}`, data);
  },

  async deleteEntry(slug: string): Promise<{ ok: string }> {
    return apiPost<{ ok: string }>(`/fieldguide/entries/${slug}/delete`);
  },

  // ==========================================================================
  // REORDER
  // ==========================================================================

  async reorder(data: {
    sections?: string[];
    entries?: Record<string, string[]>;
  }): Promise<{ ok: string }> {
    return apiPost<{ ok: string }>('/fieldguide/reorder', data);
  },
};
